import { Component, inject, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  template: `
    <div class="offer-modal__processing">
      <div class="offer-modal__content">
        Processing of your request may take a while, depending on the amount of products needed to be exported.
      </div>
      <div class="offer-modal__actions">
        <button
          nz-button
          class="offer-modal__actions--default"
        >
          <i
            nz-icon
            nzType="loading"
          ></i
          >Processing...
        </button>
        <button
          id="offer-modal__processing__actions__terminate disabled"
          nz-button
          nzType="link"
          (click)="onTerminate()"
        >
          Terminate
        </button>
      </div>
    </div>
  `,
  imports: [NzButtonModule, NzIconModule],
  standalone: true
})
export class ProcessingModalComponent implements OnInit {
  private modalData = inject(NZ_MODAL_DATA);

  public onTerminate: () => void = () => {};

  ngOnInit() {
    this.onTerminate = this.modalData.onTerminate;
  }
}
